// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1lrNq","label":"styles_label__1OLx-"};